module.exports = __webpack_public_path__ + "img/cashin-hand.3572efe5.svg";